import request from '../../utils/request'

// 查询模版文件列表
export function fetchList (templateId) {
  return request.get(`/template/file/list/${templateId}`)
}

// 保存文件
export function saveFile (file) {
  return request.post('/template/file/save', file)
}
